/**
 * Strip non-digits for phone-style fields (use with type="text", not type="number").
 */
export function digitsOnly(value) {
  return String(value ?? "").replace(/\D/g, "");
}
